module.exports = __webpack_public_path__ + "static/disk-6caee196a495214dcb7ded3e89fdc368.jpg";